// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__jegX1","overflowing":"ReadFullNote_overflowing__1qG4j"};